<template>

    <v-tabs active-tab-key="pending_assoc" @tab-click="onTabClick">
      <v-tab-pane tab-key="pending_assoc" icon="exclamation-circle" tab="Pending Action">
        <div v-if="pendingAssociates && pendingAssociates.length" class="scrollable">
          <div v-for="assoc in pendingAssociates" :key="assoc.id" style="margin-bottom:10px">
            <Card :associate="assoc" onView="pending_assoc" />
          </div>
        </div>
        <div v-if="!pendingAssociates">
          No items to show...
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="authorized_assoc" icon="check-circle" tab="Authorized">
        <div v-if="authorizedAssociates && authorizedAssociates.length" class="scrollable">
          <div v-for="assoc in authorizedAssociates" :key="assoc.id" style="margin-bottom:10px">
            <Card :associate="assoc" onView="authorized_assoc" />
          </div>
        </div>
        <div v-if="!authorizedAssociates">
          No items to show...
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="rejected_assoc" icon="close-circle" tab="Rejected">
        <div v-if="rejectedAssociates && rejectedAssociates.length" class="scrollable">
          <div v-for="assoc in rejectedAssociates" :key="assoc.id" style="margin-bottom:10px">
            <Card :associate="assoc" onView="rejected_assoc" />
          </div>
        </div>
        <div v-if="!rejectedAssociates">
          No items to show...
        </div>
      </v-tab-pane>

      <v-tab-pane tab-key="onhold_assoc" icon="pause-circle" tab="On Hold">
        <div v-if="onholdAssociates && onholdAssociates.length" class="scrollable">
          <div v-for="assoc in onholdAssociates" :key="assoc.id" style="margin-bottom:10px">
            <Card :associate="assoc" onView="onhold_assoc" />
          </div>
        </div>
        <div v-if="!onholdAssociates">
          No items to show...
        </div>
      </v-tab-pane>
    </v-tabs>

</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

const Card = Vue.component('Card', {
  template: `<v-card :title="associate.company_details.company_name + ', ' + associate.company_details.city + ', ' + 
              associate.company_details.province + ' - ' + associate.company_details.country + ', ' + associate.company_details.zip_code +
              ' (' + associate.company_details.website + ')'">

            <div class="personal-details">
              <p v-if="associate.personal_details"><b><v-icon type="user"></v-icon>&nbsp;Authorized person:</b>
              &emsp;{{associate.personal_details.first_name}}&nbsp;{{associate.personal_details.last_name}}</p>

              <p v-if="associate.personal_details && associate.company_details"><b><v-icon type="mail"></v-icon>&nbsp;e-Mail:</b>
              &emsp;{{associate.personal_details.business_email}} (B);&nbsp;{{associate.personal_details.personal_email}} (P)</p>

              <p v-if="associate.personal_details && associate.company_details"><b><v-icon type="phone"></v-icon>&nbsp;Phone Number:</b>
              &emsp;{{associate.company_details.phone_number}} (B);&nbsp;{{associate.personal_details.phone_number}} (P)</p>
            </div>

            <div class="margin-top:10px;">
              <p v-if="associate.company_details"><b><v-icon type="environment-o"></v-icon>&nbsp;Branch office locations:</b>
              &emsp;{{associate.company_details.branch_office_locations}}</p>
            </div>

            <div style="margin-top: 10px;">
              <ul>
                <li>
                  Do you collaborate with any other Study Abroad agency ?&emsp;
                  <b>{{associate.company_details.collaborate_study_abroad_agency}}</b>
                </li>
                <li>
                  Primary Country of expertise for study abroad ?&emsp;
                  <b>{{associate.company_details.primary_country_expertise_study_abroad}}</b>
                </li>
                <li>
                  How many students your agency sent abroad in the last year ?&emsp;
                  <b>{{associate.company_details.students_sent_abroad_last_year}}</b>
                </li>
                <li>
                  How many students do you anticipate to send to Canada every year?&emsp;
                  <b>{{associate.company_details.students_anticipate_send_canada_every_year}}</b>
                </li>
                <li>
                  Years of expertise(yrs)&emsp;
                  <b>{{associate.company_details.years_of_expertise}}</b>
                </li>
              </ul>
            </div>
            
            <div style="margin-top: 1px;display: flex;justify-content: flex-end;">
              <v-button type="success" @click="() => aurhorizeAssoc(associate, onView)" style="margin-left: 6px"
                v-if="(associate.status === 'Details Submitted') || (associate.status === 'On Hold')">Authorize</v-button>
              <v-button type="warning" @click="() => holdAssoc(associate, onView)" style="margin-left: 6px"
                v-if="(associate.status === 'Details Submitted')">On Hold</v-button>
              <v-button type="error" @click="() => rejectAssoc(associate, onView)" style="margin-left: 6px"
                v-if="(associate.status === 'Details Submitted') || (associate.status === 'On Hold')">Reject</v-button>
            </div>
          </v-card>`,
  props: ['associate', 'onView'],
  methods: {
    aurhorizeAssoc (assoc, onView) {
      this.$store.dispatch('updateAssocStatus', {
        uid: assoc.id,
        onView: onView,
        payload: {status: 'Authorized'}})
    },
    holdAssoc (assoc, onView) {
      this.$store.dispatch('updateAssocStatus', {
        uid: assoc.id,
        onView: onView,
        payload: {status: 'On Hold'}})
    },
    rejectAssoc (assoc, onView) {
      this.$store.dispatch('updateAssocStatus', {
        uid: assoc.id,
        onView: onView,
        payload: {status: 'Rejected'}})
    }
  }
})

export default {
  name: 'AssociatesView',
  computed: {
    ...mapGetters([
      'pendingAssociates',
      'authorizedAssociates',
      'rejectedAssociates',
      'onholdAssociates'
    ])
  },
  watch: {
    pendingAssociates: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getPendingAssociates')
        } else {
          console.log(this.pendingAssociates)
        }
      },
      immediate: true
    }
  },
  methods: {
    onTabClick (tabKey) {
      if (tabKey === 'pending_assoc' && !this.pendingAssociates) {
        this.$store.dispatch('getPendingAssociates')
      } else if (tabKey === 'authorized_assoc' && !this.authorizedAssociates) {
        this.$store.dispatch('getAuthorizedAssociates')
      } else if (tabKey === 'rejected_assoc' && !this.rejectedAssociates) {
        this.$store.dispatch('getRejectedAssociates')
      } else if (tabKey === 'onhold_assoc' && !this.onholdAssociates) {
        this.$store.dispatch('getOnholdAssociates')
      }
    }
  },
  components: {
    Card
  }
}
</script>

<style scoped>
.scrollable {
}
.ant-card-head {
  background: #404040 !important;
}
.ant-card-head-title {
  color: ivory !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/AssociatesView.vue